"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonGroup = exports.Button = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _polished = require("polished");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Progress = (0, _styledComponents.keyframes)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n100%{\n  width: 100%;\n}"])));
var hidder = (0, _styledComponents.keyframes)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n99%{\n  width: 0;\n  height: 0;\n  border-radius: 25px;\n}\n100%{\n  /* display: none; */\n}"])));
var ButtonWrapper = (0, _styledComponents["default"])('div').attrs({
  className: 'flexi-button'
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: inline-flex;\n    overflow: hidden;\n    align-items: center;\n    position: relative;\n    vertical-align:top;\n    cursor: pointer;\n    height: ", "px;\n    width: ", "px;\n    ", "\n    ", "\n    background-color: ", "; \n    padding: ", ";\n    color: ", ";\n    border-radius: ", ";\n    font-size: ", ";\n    transition: ", ";\n    ", "\n    ", "\n\n    ", "\n    &:hover{\n      background-color: ", "; \n    }\n\n    ", "\n\n    ", "\n\n    & .flexi-button-center{\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-grow: 1;\n    }\n    ", "\n  ", "\n  & span{\n    position: relative;\n    z-index: 1;\n  }\n  ", "\n  ", "\n  ", "\n"])), function (props) {
  return props.height;
}, function (props) {
  return props.width;
}, function (props) {
  return props.block && (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        display: flex;\n      "])));
}, function (props) {
  return props.bold && (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        font-weight: bold;\n      "])));
}, function (props) {
  return props.color ? props.color : props.theme.PrimaryColor;
}, function (props) {
  return props.pad;
}, function (props) {
  return props.fontColor;
}, function (props) {
  return props.round ? "".concat(props.height / 2, "px") : props.theme.PrimaryRadius;
}, function (props) {
  return props.font ? props.font : props.theme.PrimaryFontSize;
}, function (props) {
  return props.theme.PrimaryTransition;
}, function (props) {
  return props.spaceLeft && (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n        margin-left: ", ";\n      "])), function (props) {
    return props.spaceLeft.length >= 3 ? props.spaceLeft : '10px';
  });
}, function (props) {
  return props.spaceRight && (0, _styledComponents.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n        margin-right: ", ";\n      "])), function (props) {
    return props.spaceRight.length >= 3 ? props.spaceRight : '10px';
  });
}, function (props) {
  return props.elevate && (0, _styledComponents.css)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n        ", ";\n      "])), function (props) {
    return props.elevate != 'low' ? props.theme.Elevate[props.elevate] : props.theme.Elevate.low;
  });
}, function (props) {
  return (0, _polished.darken)(0.1, props.color ? props.color : props.theme.PrimaryColor);
}, function (props) {
  return props.pale && (0, _styledComponents.css)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n        border: 1px solid\n          ", ";\n        color: ", ";\n        z-index: 0;\n        background: ", ";\n        &:hover {\n          background: ", ";\n        }\n        ", "\n      "])), function (props) {
    return props.color ? props.color : props.theme.PrimaryColor;
  }, function (props) {
    return props.fontColor != '#fff' ? props.fontColor : props.theme.PrimaryColor;
  }, function (props) {
    return (0, _polished.transparentize)(1, props.color ? props.color : props.theme.PrimaryColor);
  }, function (props) {
    return (0, _polished.transparentize)(0.8, props.color ? props.color : props.theme.PrimaryColor);
  }, function (props) {
    return props.shaded && (0, _styledComponents.css)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n            background: ", ";\n            &:hover {\n              background: ", ";\n            }\n          "])), function (props) {
      return (0, _polished.transparentize)(0.8, props.color ? props.color : props.theme.PrimaryColor);
    }, function (props) {
      return (0, _polished.transparentize)(0.6, props.color ? props.color : props.theme.PrimaryColor);
    });
  });
}, function (props) {
  return props.plain && (0, _styledComponents.css)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n        border: none;\n        color: ", ";\n        background: none;\n        &:hover {\n          background: ", ";\n        }\n      "])), function (props) {
    return props.fontColor != '#fff' ? props.fontColor : props.color ? props.color : props.theme.PrimaryColor;
  }, function (props) {
    return (0, _polished.transparentize)(0.95, props.color ? props.color : props.theme.PrimaryColor);
  });
}, function (props) {
  return props.iconLeft && (0, _styledComponents.css)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n        padding-left: 0;\n        & .flexi-button-icon-left {\n          flex-grow: 0;\n          width: ", "px;\n          height: ", "px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          & img {\n            height: ", "px;\n          }\n          & i {\n            font-size: ", "px;\n          }\n        }\n      "])), function (props) {
    return props.height;
  }, function (props) {
    return props.height;
  }, function (props) {
    return props.height / 2;
  }, function (props) {
    return props.height / 3;
  });
}, function (props) {
  return props.iconRight && (0, _styledComponents.css)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n      padding-right: 0;\n      & .flexi-button-icon-right {\n        flex-grow: 0;\n        width: ", "px;\n        height: ", "px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        & img {\n          height: ", "px;\n        }\n        & i {\n          font-size: ", "px;\n        }\n      }\n    "])), function (props) {
    return props.height;
  }, function (props) {
    return props.height;
  }, function (props) {
    return props.height / 2;
  }, function (props) {
    return props.height / 3;
  });
}, function (props) {
  return props.progress && (0, _styledComponents.css)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n      overflow: hidden;\n      &:after {\n        content: '';\n        display: block;\n        width: 0;\n        height: 100%;\n        background: rgba(255, 255, 255, 0.1);\n        ", "\n        position: absolute;\n        top: 0;\n        left: 0;\n        z-index: 1;\n        animation: ", " 1.5s linear infinite alternate both;\n      }\n      &:hover {\n        & span.flexi-button-center {\n          filter: blur(0.5px);\n        }\n      }\n    "])), function (props) {
    return props.pale && (0, _styledComponents.css)(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n            background: ", ";\n          "])), function (props) {
      return (0, _polished.transparentize)(0.9, (0, _polished.darken)(0.1, props.color ? props.color : props.theme.PrimaryColor));
    });
  }, Progress);
}, function (props) {
  return props.disabled && (0, _styledComponents.css)(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n      background-color: rgba(0, 0, 0, 0.2);\n      color: rgba(0, 0, 0, 0.3);\n      ", "\n      &:hover {\n        background-color: rgba(0, 0, 0, 0.15);\n        color: rgba(0, 0, 0, 0.3);\n        ", "\n        & span {\n          filter: blur(0.5px);\n        }\n      }\n    "])), function (props) {
    return props.pale && (0, _styledComponents.css)(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n          background: none;\n          border: 1px dashed rgba(0, 0, 0, 0.3);\n        "])));
  }, function (props) {
    return props.pale && (0, _styledComponents.css)(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n            background: none;\n            border: 1px dashed rgba(0, 0, 0, 0.25);\n          "])));
  });
}, function (props) {
  return props.hide && (0, _styledComponents.css)(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n      display: none;\n    "])));
});
var Button = function Button(props) {
  return /*#__PURE__*/_react["default"].createElement(ButtonWrapper, _extends({}, props, {
    onClick: !props.progress && !props.disabled ? props.onClick : function () {}
  }), props.iconLeft && /*#__PURE__*/_react["default"].createElement("span", {
    className: "flexi-button-icon-left"
  }, props.progress ? /*#__PURE__*/_react["default"].createElement("i", {
    className: "flexibull-spin6 animate-spin"
  }) : props.iconLeft), props.icon && /*#__PURE__*/_react["default"].createElement("span", {
    className: "flexi-button-center"
  }, props.icon), props.children && /*#__PURE__*/_react["default"].createElement("span", {
    className: "flexi-button-center"
  }, props.children), props.iconRight && /*#__PURE__*/_react["default"].createElement("span", {
    className: "flexi-button-icon-right"
  }, props.progress ? /*#__PURE__*/_react["default"].createElement("i", {
    className: "flexibull-spin6 animate-spin"
  }) : props.iconRight));
};
exports.Button = Button;
var ButtonGroupWrapper = (0, _styledComponents["default"])('div').attrs({
  className: 'flexi-button-group'
})(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  content: \"\";\n  clear: both;\n  display: table;\n  height: ", "px;\n\n  & .flexi-button {\n    border-radius: 0 !important;\n    height: ", "px;\n    margin-left: -1px !important;\n\n    &:first-child {\n      border-radius: ", " 0 0 ", " !important;\n      margin-left: 0;\n    }\n\n    &:last-child {\n      border-radius: 0 ", " ", " 0 !important;\n    }\n  }\n\n  ", "\n"])), function (props) {
  return props.height;
}, function (props) {
  return props.height;
}, function (props) {
  return props.theme.PrimaryRadius;
}, function (props) {
  return props.theme.PrimaryRadius;
}, function (props) {
  return props.theme.PrimaryRadius;
}, function (props) {
  return props.theme.PrimaryRadius;
}, function (props) {
  return props.round && (0, _styledComponents.css)(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n    & .flexi-button {\n      border-radius: 0 !important;\n    height: ", "px;\n    margin-left: -1px !important;\n      &:first-child {\n        border-radius: ", " 0 0 ", " !important;\n      }\n\n      &:last-child {\n        border-radius: 0 ", " ", " 0 !important;\n      }\n    }\n      \n  "])), function (props) {
    return props.height;
  }, function (props) {
    return "".concat(props.height / 2, "px");
  }, function (props) {
    return "".concat(props.height / 2, "px");
  }, function (props) {
    return "".concat(props.height / 2, "px");
  }, function (props) {
    return "".concat(props.height / 2, "px");
  });
});
var ButtonGroup = function ButtonGroup(props) {
  return /*#__PURE__*/_react["default"].createElement(ButtonGroupWrapper, props, props.children);
};
exports.ButtonGroup = ButtonGroup;
Button.defaultProps = {
  block: false,
  spaceLeft: false,
  spaceRight: false,
  round: false,
  fontColor: '#fff',
  height: 38,
  pad: '0 15px',
  elevate: false,
  pale: false
};
Button.propTypes = {
  block: _propTypes["default"].bool,
  bold: _propTypes["default"].bool,
  plain: _propTypes["default"].bool,
  color: _propTypes["default"].string,
  spaceLeft: _propTypes["default"].any,
  spaceRight: _propTypes["default"].any,
  iconLeft: _propTypes["default"].element,
  iconRight: _propTypes["default"].element,
  children: _propTypes["default"].any,
  height: _propTypes["default"].number,
  fontColor: _propTypes["default"].string,
  round: _propTypes["default"].bool,
  pad: _propTypes["default"].string,
  font: _propTypes["default"].number,
  elevate: _propTypes["default"].any,
  pale: _propTypes["default"].bool,
  progress: _propTypes["default"].bool,
  width: _propTypes["default"].number
};
ButtonGroup.defaultProps = {
  round: false,
  height: 32
};
ButtonGroup.protoTypes = {
  round: _propTypes["default"].bool,
  height: _propTypes["default"].number
};